import CommonMapper from '@/modules/core/mappers/CommonMapper'

import type LifeHiringInsured from '@/modules/life/hiring/models/APP/LifeHiringInsured'
import LifeSavePolicyHolderRequest from '@/modules/life/hiring/models/MID/requests/LifeSavePolicyHolderRequest'

export default class SavePolicyHolderMapper {
  static toRequest(quotationId: string, holder: LifeHiringInsured): LifeSavePolicyHolderRequest {
    const dataProtection = {
      dataTransfer: holder.dataTransfer,
      thirdPartyTelephoneAdvertising: holder.thirdPartyTelephoneAdvertising,
      thirdPartyWrittenAdvertising: holder.thirdPartyWrittenAdvertising
    }
    return new LifeSavePolicyHolderRequest({
      quotationId,
      policyHolder: {
        role: holder.role,
        name: (holder.userDetails.name ?? '').toUpperCase(),
        firstSurname: (holder.userDetails.surname1 ?? '').toUpperCase(),
        secondSurname: (holder.userDetails.surname2 ?? '').toUpperCase(),
        birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate),
        sex: holder.userDetails.gender,
        street: holder.addressDetails.address,
        city: holder.addressDetails.city,
        house: holder.addressDetails.roadNumber,
        postalCode: holder.addressDetails.postalCode,
        province: holder.addressDetails.province,
        houseType: holder.addressDetails.houseType,
        gateway: holder.addressDetails.gateway,
        stair: holder.addressDetails.stair,
        floor: holder.addressDetails.floor,
        doorway: holder.addressDetails.doorway,
        restAddres: holder.addressDetails.addressExtra,
        addressNormalice: holder.addressDetails.addressNormalize,
        streetType: holder.addressDetails.streetType,
        email: holder.userDetails.email,
        prefix: holder.userDetails.prefix,
        mobilePhone: holder.userDetails.phone
      },
      dataProtection: !holder.thirdPartiesAnswered ? dataProtection : undefined
    })
  }
}
